var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3005_13853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3005_13853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62195 26.4249C5.95735 26.4249 5.38338 26.1822 4.90005 25.6968C4.41672 25.2114 4.17505 24.6364 4.17505 23.9718C4.17505 23.3072 4.41775 22.7332 4.90315 22.2499C5.38855 21.7666 5.96355 21.5249 6.62815 21.5249C7.29275 21.5249 7.86672 21.7676 8.35005 22.253C8.83338 22.7384 9.07505 23.3134 9.07505 23.978C9.07505 24.6426 8.83235 25.2166 8.34695 25.6999C7.86155 26.1832 7.28655 26.4249 6.62195 26.4249ZM10.25 39.7499L8.20005 37.6999L16.725 29.1749L18.775 31.2249L10.25 39.7499ZM16.725 18.6999L8.25005 10.2249L10.3 8.1749L18.775 16.6499L16.725 18.6999ZM24.0219 43.8249C23.3573 43.8249 22.7834 43.5822 22.3 43.0968C21.8167 42.6114 21.575 42.0364 21.575 41.3718C21.575 40.7072 21.8178 40.1332 22.3032 39.6499C22.7886 39.1666 23.3636 38.9249 24.0282 38.9249C24.6928 38.9249 25.2667 39.1676 25.75 39.653C26.2334 40.1384 26.475 40.7134 26.475 41.378C26.475 42.0426 26.2323 42.6166 25.7469 43.0999C25.2615 43.5832 24.6865 43.8249 24.0219 43.8249ZM24.0219 9.0499C23.3573 9.0499 22.7834 8.8072 22.3 8.3218C21.8167 7.8364 21.575 7.2614 21.575 6.5968C21.575 5.9322 21.8178 5.35824 22.3032 4.8749C22.7886 4.39157 23.3636 4.1499 24.0282 4.1499C24.6928 4.1499 25.2667 4.3926 25.75 4.878C26.2334 5.3634 26.475 5.9384 26.475 6.603C26.475 7.2676 26.2323 7.84157 25.7469 8.3249C25.2615 8.80824 24.6865 9.0499 24.0219 9.0499ZM31.3 18.6999L29.25 16.6499L37.725 8.1749L39.7751 10.2249L31.3 18.6999ZM37.725 39.6999L29.25 31.2249L31.3 29.1749L39.7751 37.6499L37.725 39.6999ZM41.3969 26.4249C40.7323 26.4249 40.1584 26.1822 39.675 25.6968C39.1917 25.2114 38.9501 24.6364 38.9501 23.9718C38.9501 23.3072 39.1928 22.7332 39.6782 22.2499C40.1636 21.7666 40.7385 21.5249 41.4031 21.5249C42.0677 21.5249 42.6417 21.7676 43.125 22.253C43.6084 22.7384 43.85 23.3134 43.85 23.978C43.85 24.6426 43.6073 25.2166 43.1219 25.6999C42.6365 26.1832 42.0615 26.4249 41.3969 26.4249Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.2db32fd1f0a2ecca260cd942fcba2146.svg";
export { ForwardRef as ReactComponent };